import type { QueryClient } from '@tanstack/react-query';

let instance: QueryClient | null = null;

export function registerQueryClient(client: QueryClient): void {
  instance = client;
}

export function getQueryClient(): QueryClient | null {
  return instance;
}
